import * as types from './mutations-type'

const mutations = {
    [types.CRON_LOG_ID](state, payload) {
        state.cron_log_id = payload
    },
    [types.PAGE](state, payload) {
        state.page = payload
    },
    [types.PERPAGE](state, payload) {
        state.perpage = payload
    },
    [types.LOG_COUNTS](state, payload) {
        state.tot_logs = payload
    },
    [types.LAST_PAGE](state, payload) {
        state.last_page = payload
    },
    [types.RESPONSE_PAYLOAD](state, payload) {
        state.responsePayload = payload
    },
}

export default mutations